import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;

export const fetchAsyncDeleteCreditAmount = createAsyncThunk(
  "/fetchAsyncDeleteCreditAmount",
  async (id) => {
    try {
      const response = await axiosInstance.delete(`${API_URL}/credit/delete-credit-amount/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);


export const fetchAsyncDeleteCreditFile = createAsyncThunk(
  "/fetchAsyncDeleteCreditFile",
  async (data) => {
    try {
      let url = `${API_URL}/credit/delete_credit_file/${data.creditId}`;
      const response = await axiosInstance.post(url,{spId:data?.spId});
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);
export const fetchAsyncGetTotalCreditAmount = createAsyncThunk(
  "/fetchAsyncGetTotalCreditAmount",
  async (vendorId) => {
    try {
      let url = `${API_URL}/credit/get-total-credit-amount/${vendorId}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncGetNewCreditNumber = createAsyncThunk(
  "/fetchAsyncGetNewCreditNumber",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/credit/get-new-creditt-number`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncGetAllCreditByExpenseId = createAsyncThunk(
  "/fetchAsyncGetAllCreditByExpenseId",
  async (expenseId) => {
    try {
      let url = `${API_URL}/credit/get-all-expense-credit/${expenseId}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncCreateNewCredit = createAsyncThunk(
  "/fetchAsyncCreateNewCredit",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/credit/create-new-credit/${data?.moduleId}`, data?.formData);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncGetCreditDetailsByVendorId = createAsyncThunk(
  "/fetchAsyncGetCreditDetailsByVendorId",
  async (vendorId) => {
    try {
      let url = `${API_URL}/credit/get-credit-details/${vendorId}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncDeleteVendorCredit = createAsyncThunk(
  "/fetchAsyncDeleteVendorCredit",
  async ({vendorId, creditId}) => {
    try {
      let url = `${API_URL}/credit/delete-vendor-credit/${vendorId}/${creditId}`;
      const response = await axiosInstance.delete(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncGetCreditOptionsByVendorId = createAsyncThunk(
  "/fetchAsyncGetCreditOptionsByVendorId",
  async (vendorId) => {
    try {
      let url = `${API_URL}/credit/get-credit-options/${vendorId}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);
export const fetchAsyncGetCreditOptionsByClientId = createAsyncThunk(
  "/fetchAsyncGetCreditOptionsByClientId",
  async (clientId) => {
    try {
      let url = `${API_URL}/credit/get-client-credits/${clientId}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncDeleteCreditListItem = createAsyncThunk(
  "/fetchAsyncDeleteCreditListItem",
  async (data) => {
    try {
      let url = `${API_URL}/credit/delete-credit-list-item/${data.moduleId}/${data.creditId}`;
      const response = await axiosInstance.post(url,data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncUpdateCredit = createAsyncThunk(
  "/fetchAsyncUpdateCredit",
  async (data) => {
    try {
      const response = await axiosInstance.put(`${API_URL}/credit/update/${data?.id}`, data?.formData);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncGetCreditDetailsByClientId = createAsyncThunk(
  "/fetchAsyncGetCreditDetailsByClientId",
  async (clientId) => {
    try {
      let url = `${API_URL}/credit/client-credit-details/${clientId}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);
export const fetchAsyncAddCreditByVendor = createAsyncThunk(
  "/fetchAsyncAddCreditByVendor",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/credit/add-credit`, data?.formData);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncCreateNewSalesCredit = createAsyncThunk(
  "/fetchAsyncCreateNewSalesCredit",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/credit/create-new-sales-credit/${data?.moduleId}`, data?.formData);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);